import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { Sticky } from '@bd/bdcore-utilities';

import PageMenu from '../../components/PageMenu';
import { colors } from '../../styles';

const styles = css`
  width: 100%;
  height: auto;
  transition: all .3s ease-out;
  background-color: ${colors.bodyLight};
  @media(min-width: 992px) {
    top: 0 !important;
    padding: 0;
    position: relative !important;
  }
  @supports(position: sticky) {
    top: 59px !important;
    z-index: 11 !important;
    position: sticky !important;
    @media(min-width: 992px) {
      top: 105px !important;
    }
  }

  .page-menu {
    background-color: ${colors.bodyLight};
    padding: 0;
    @media(min-width: 992px) {
      display: flex;
      justify-content: center;
    }

    a {
      @media(min-width: 992px) {
        color: ${colors.white};
      }
    }
  }
`;

const PlanMenu = ({ plan }) => {
  return (
    <Sticky className={styles}>
      <PageMenu
        title="Home Menu"
        items={[
          {
            id: '#overview',
            title: 'Overview',
            tolerance: 200,
            hide: !(plan.description),
          },
          {
            id: '#tour',
            title: 'Virtual Tour',
            tolerance: 200,
            hide: !(plan.virtual_tour),
          },
          {
            id: '#elevations',
            title: 'Elevations',
            tolerance: 200,
            hide: !(plan.elevationPhotos.length > 0),
          },
          {
            id: '#plans',
            title: 'Floor Plans',
            tolerance: 200,
            hide: !(plan.floorplanPhotos.length > 0),
          },
          {
            id: '#photos',
            title: 'Photos',
            tolerance: 200,
            hide: !(plan.photos.length > 1),
          },
          {
            id: '#availability',
            title: 'Availability',
            tolerance: 200,
          },
        ]}
      />
    </Sticky>
  );
};

PlanMenu.propTypes = {
  plan: PropTypes.object.isRequired,
};

export default withData(
  {
    plan: true,
  },
  {
    required: {
      plan: true,
    },
  },
)(PlanMenu);



// WEBPACK FOOTER //
// ./src/pages/PlanDetail/PlanMenu.js